// Placeholder images for missing assets
// These should be replaced with actual WebP images

export const placeholders = {
  bookCover: require('./book/top-book-cover.webp'),
  guruAvatar: require('./onboarding/guru-placeholder.webp'),
  mascotDefault: require('./mentor/mentor-default.webp'),
  mascotGreeting: require('./mentor/mentor-welcome.webp'),
};

// All placeholder images have been properly linked:
// - Book cover placeholder: assets/book/top-book-cover.webp
// - Guru avatar placeholder: assets/onboarding/guru-placeholder.webp
// - Mascot default: assets/mentor/mentor-default.webp
// - Mascot greeting: assets/mentor/mentor-welcome.webp 